import {cloneDeep} from 'lodash'

export const state = () => ({
	sidebar: false,
});

export const actions = {
	nuxtServerInit ({commit}) {
		commit('setDefault');
	},
};

export const mutations = {
	toggleSidebar(state) {
		state.sidebar = !state.sidebar;
	},
	setDefault(state) {
		state.default = {
		    systemadmin: cloneDeep(state.app.systemadmin),
		    tenantadmin: cloneDeep(state.app.tenantadmin),
		    user: cloneDeep(state.app.user)
		};
	},
	resetDefault(state) {
		state.app.systemadmin = cloneDeep(state.default.systemadmin);
		state.app.tenantadmin = cloneDeep(state.default.tenantadmin);
		state.app.user = cloneDeep(state.default.user);
	},
};
